var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 h-100"},[_c('div',{staticClass:"z-0 fixed top-0 left-0 right-0 bottom-0 w-100 h-100",attrs:{"id":"map"}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }